export function recodeMenuOpenTime (menu) {
  if (!menu) return
  try {
    const now = Date.now()
    console.log('【路由组件打开时间记录】', menu.id, now)
    window.__ERP_MENU_OPEN_TIME__ = window.__ERP_MENU_OPEN_TIME__ || {}
    window.__ERP_MENU_OPEN_TIME__[menu.id] = now
  } catch (e) {
    console.warn(e)
  }
}



// WEBPACK FOOTER //
// ./src/layout/router/helpers/recode-moudle-open-time.js